// extracted by mini-css-extract-plugin
export default {"root":"NotFoundBlock_root__iQYuo","description":"NotFoundBlock_description__nulrq"};